import { Component, OnInit } from '@angular/core';
import { ClinicService } from 'src/app/_services/clinic.service';
import { UserService } from 'src/app/_services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Location } from '@angular/common';

@Component({
  selector: 'app-nurse-details',
  templateUrl: './nurse-details.component.html',
  styleUrls: ['./nurse-details.component.scss'],
  providers: [MessageService]
})
export class NurseDetailsComponent implements OnInit {
  currentNurse: any;
  isSubmitting: boolean = false;
  loading: boolean = true;

  constructor(
    private clinicService: ClinicService,
    private userService: UserService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private location: Location
  ) {}

  form = this.fb.group({
    sanc_number: ['', Validators.required],
    practice_number: ['', Validators.required],
    sanc_qualification: ['', Validators.required],
    contact_number: ['', Validators.required],
    alternate_contact_number: [''],
    user: this.fb.group({
      username: ['', Validators.required],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    }),
  });

  ngOnInit(): void {
    this.clinicService.getCurrentNurse().subscribe(
      (response: any) => {
        console.log('Current Nurse Data:', response);
        this.currentNurse = response.body;

        this.form = this.fb.group({
          sanc_number: [this.currentNurse.sanc_number, Validators.required],
          practice_number: [
            this.currentNurse.practice_number,
            Validators.required,
          ],
          sanc_qualification: [
            this.currentNurse.sanc_qualification,
            Validators.required,
          ],
          contact_number: [
            this.currentNurse.contact_number,
            Validators.required,
          ],
          alternate_contact_number: [
            this.currentNurse.alternate_contact_number || '',
          ],
          user: this.fb.group({
            username: [this.currentNurse.user.username, Validators.required],
            first_name: [
              this.currentNurse.user.first_name,
              Validators.required,
            ],
            last_name: [this.currentNurse.user.last_name, Validators.required],
            email: [
              this.currentNurse.user.email,
              [Validators.required, Validators.email],
            ],
          }),
        });
        
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching current nurse data:', error);
        this.loading = false;
        this.messageService.add({
          key: 'nurse-details',
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load profile data. Please refresh the page.'
        });
      }
    );
  }

  onSubmit(): void {
    if (this.form.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      
      this.clinicService
        .updateNurse(this.currentNurse.user_id, this.form.value)
        .subscribe({
          next: (response) => {
            console.log('Nurse updated successfully:', response);
            this.messageService.add({
              key: 'nurse-details',
              severity: 'success',
              summary: 'Success',
              detail: 'Profile updated successfully'
            });
            this.isSubmitting = false;
          },
          error: (error) => {
            console.error('Error updating nurse:', error);
            this.messageService.add({
              key: 'nurse-details',
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to update profile. Please try again.'
            });
            this.isSubmitting = false;
          },
        });
    } else if (!this.form.valid) {
      // Mark all fields as touched to show validation errors
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        control?.markAsTouched();
        
        // Mark nested form group controls as touched
        if (control instanceof FormGroup) {
          Object.keys(control.controls).forEach(nestedKey => {
            control.get(nestedKey)?.markAsTouched();
          });
        }
      });
      
      this.messageService.add({
        key: 'nurse-details',
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Please fill in all required fields correctly'
      });
    }
  }

  onCancel(): void {
    this.location.back();
  }
}
